import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { RouteTreeChartDto } from './RouteTreeChartDto';
import { RouteTreeChartRowDto } from './RouteTreeChartRowDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';

@Component({
  selector: 'shared-route-chart',
  templateUrl: './shared.route.chart.component.html',
  styleUrls: ['./shared.route.chart.component.scss'],
})
export class SharedRouteChartComponent implements OnInit, OnDestroy {

  public actions: ActionsStripDto;

  constructor(
    private routeController: RouteController) {
  }

  ngOnInit(): void {
    this.actions = ActionsStripDto.buildDefaultActionsForGetDataOnlyButton();
  }
  ngOnDestroy(): void {
  }

  public value: RouteTreeChartDto;

  public __routeId: number;
  @Input()
  set routeId(value: number) {
    if (this.__routeId === value)
      return;
    this.__routeId = value;
    this.getData();
  }
  get routeId(): number {
    return this.__routeId;
  }

  public getData() {
    if (!this.routeId)
      return;

    this.routeController.getRouteTreeChart(this.routeId).subscribe(chart => {
      this.value = chart;
    });
  }

  onClickAction($event: ActionDto) {
    if ($event.actionId === "GETDATA") {
      this.getData();
    }
  }
  get rowsList(): RouteTreeChartRowDto[] {
    return Object.values(this.value?.rows || {});
  }
  public pretty(value) {
    return JSON.stringify(value);
  }
}
